import { flowRight } from 'lodash';
import { withTheme } from 'styled-components';

// Zocdoc dependencies
import { withCustomMetrics } from '@zocdoc/frontend-metrics';

// BWA
import DoctorCardHeader from './DoctorCardHeader';
import withProvider from '../../../gql/withProvider.js';

export default flowRight(
    withTheme,
    withProvider,
    withCustomMetrics({
        component: 'LightweightDoctorCard',
    })
)(DoctorCardHeader);
